module.exports = __webpack_public_path__ + "static/media/CTLI_17-147w.e3f9558e.png";